import { get, post, put, _delete } from './Tools';

const BASE = process.env.REACT_APP_SERVER;
const RESOURCE = 'dias_festivos';

// GET: lista de días festivos (filtrados por company del usuario en el backend)
const getAll = async () => {
  const response = await get(`${BASE}${RESOURCE}`);
  return response;
};

// GET: día festivo por id
const getById = async (id) => {
  const response = await get(`${BASE}${RESOURCE}/${id}`);
  return response;
};

// POST: crear día festivo (payload = DiasFestivosBase)
const insert = async (payload) => {
  const response = await post(`${BASE}${RESOURCE}`, payload);
  return response;
};

// PUT: actualizar día festivo (payload debe incluir id)
const update = async (payload) => {
  const response = await put(`${BASE}${RESOURCE}`, payload);
  return response;
};

// DELETE: eliminar día festivo por id
const remove = async (id) => {
  const response = await _delete(`${BASE}${RESOURCE}/${id}`);
  return response;
};

export { getAll, getById, insert, update, remove };